<template>




<v-form v-model="valid">
  <v-container>

    <v-app-bar
      app
      color="grey lighten-4"
    >

     <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>


          <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://conciergepad-images.s3.amazonaws.com/concierge_logo.png"
          transition="scale-transition"
          width="250"
        />
        </div>

    
         </v-app-bar>


<v-navigation-drawer
        v-model="drawer"
        :color="color"
        :expand-on-hover="expandOnHover"
        :mini-variant="miniVariant"
        :right="right"
        :permanent="permanent"
        :src="bg"
        absolute
        temporary
        dark
      >
        <v-list
          dense
          nav
          class="py-0"
        >
          <v-list-item two-line :class="miniVariant && 'px-0'">

            <v-list-item-content>
              <v-list-item-title>Menu</v-list-item-title>
              <v-list-item-subtitle>Please select link from sidebar</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item
            v-for="item in itemsDrawer"
            :key="item.title"
            link
            @click="$router.push({ path: item.route })"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>



<v-banner single-line>
    <v-icon
      slot="icon"
      color="warning"
      size="36"
    >
      mdi-shield-account
    </v-icon>
    Your Membership Number
    <template v-slot:actions>
      
        {{loginUuid}}
     
    </template>
  </v-banner>



       <v-card
    class="mx-auto">
    <v-card-text>
      <div class="text--primary">
        Add Student to Profile (Please make sure to add Student ID FIRST and then Date of Birth)
      </div>
    </v-card-text>
    <v-card-text>
      STEP 1 - Enter in Student ID first
      <v-text-field
        v-model="studentId"
        v-mask="'############'"
        label="Student ID"
           outlined
    ></v-text-field>
    </v-card-text>
    <v-card-text>
       STEP 2 - Enter in Date of Birth after Student ID has been entered above.
        <v-text-field
        v-model="studentDob"
        v-mask="'##-##-####'"
        placeholder="mm-dd-yyyy"
        label="Date of Birth"
        outlined
        @keyup="uppercase"
    ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-btn :disabled="studentExists" large color="success" v-on:click='addStudent()'>Add Student</v-btn>
    </v-card-actions>
  </v-card>

       

    

    

    <v-alert type="success" v-model="validStudent">
      Valid Student.
    </v-alert>

     <v-alert type="error" v-model="invalidStudent">
     Invalid Student
    </v-alert>




<v-banner single-line>
    <v-icon
      slot="icon"
      color="warning"
      size="36"
    >
      mdi-account-multiple
    </v-icon>
    Student(s) in Profile
    <template v-slot:actions>
      

     
    </template>
  </v-banner>


<v-data-table
    v-model="selected"
    :headers="headers"
    :items="students"
    :single-select="singleSelect"
    item-key="studenT_ID"
    class="elevation-1"
    @click:row="rowClick"
  >


 

  <template v-slot:item.id="{ item }">


      
      <v-btn color="error" v-on:click='removeStudent(item.id,item.studenT_ID,item.firsT_NAME,item.lasT_NAME,item.birthday,item.householD_ID,item.hangeR_ID)'>Remove</v-btn>

  </template>
    
  </v-data-table>







    


    </v-container>
  </v-form>


</template>


<script>

  import axios from 'axios';
  import store from '../store';
  import moment from 'moment-timezone';

  export default {
    data: () => ({

      drawer: false,
        itemsDrawer: [
          { title: 'Add Student', icon: 'mdi-account-plus', route:'#' },
          { title: 'Send Invite', icon: 'mdi-send', route:'send' },
          { title: 'Logout', icon: 'mdi-logout', route:'login' },
        ],
        color: 'primary',
        colors: [
          'primary',
          'blue',
          'success',
          'red',
          'teal',
        ],
        right: false,
        clipped: true,
        permanent: false,
        miniVariant: false,
        expandOnHover: false,
        background: false,
        singleSelect: true,
        selected: [],
        headers: [
          {
            text: 'Student ID',
            align: 'start',
            sortable: false,
            value: 'studenT_ID',
          },
          { text: 'First Name', value: 'firsT_NAME' },
          { text: 'Last Name', value: 'lasT_NAME' },
          { text: 'DOB', value: 'birthday' },
          { text: 'Household ID', value: 'householD_ID' },
          { text: 'Hanger ID', value: 'hangeR_ID' },
          { text: 'Added', value: 'datE_ADDED' },
          { text: 'Rec No', value: 'id' },
        ],
    studentExists: true,
    studentId:'',
    studentDob: '',
    validStudent: false,
    invalidStudent: false,
    guardianFirstName: '',
    studentsAttached: [],
    guardianLastName: '',
    guardianRelation: '',
    guardianEmail: '',
    guardianPhone: '',
    loginUuid:'',
    validUpdate: false,
    invalidUpdate: false,
    validEmailGuardian: false,
    invalidEmailGuardian: false,
    alreadyRegistered: '',
    studentArray: [],
    addStudentArray: '',
    hangerIdArray: [],
      passwordAlert: false,
      message: '',
      alert: false,
      loaded: false,
      results: {},
      firstName: '',
      _isMounted:false,
      pId: '',
      compName: '',
      hagnerId: '',
      jwsToken: '',
      username: '',
      password: '',
      reTypePassword: '',
      valid: true,
      validCode: false,
      invalidCode: false,
      doAdd: "N",
      items: {},
      students: [],
      name: '',
      accessToken: '',
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    }),

    mounted: function() {
      

     console.log('App mounted!');

     this.$intercom.boot({
          app_id: "naxtoq3z"
        });
        this.$intercom.show();

     
    if (localStorage.getItem('jwsToken')) this.jwsToken = JSON.parse(localStorage.getItem('jwsToken'));

     this.compName = store.state.companyName;
     this.hangerId = store.state.hangerId;
     this.loginUuid = store.state.loginUUID;


     console.log(this.loginUUID);

     this.getStudents();

  },

    methods: {


    validateStudent:function() {

      this.studentArray = [];

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      axios.get('https://api.conciergepadedu.com/api/Rosters/GetValidate/' + this.studentId + "/" + this.studentDob + "/" + this.compName,auth).then(response => {

      if (response.data.error) {

        console.log("ERROR");
        this.validStudent = false;
        this.invalidStudent = true;
        this.studentExists = true;

      } else {

        console.log("SUCCESS");
        console.log(response.data);

        this.invalidStudent = false;
        this.studentExists = false;
        this.studentArray = response.data;

        }

        }).catch(error => {

            console.log(error.response);
            console.log("CATCH");
            this.validCode = false;
            this.invalidCode = true;
            this.studentExists = true;

        });

    },

    rowClick: function (item, row) {      
      row.select(true);
      console.log(item);
      //item  - selected item
    },
    selectStudent(myItem) {

      console.log(myItem);

    },
    uppercase() {
        

        if (this.studentId.length > 0 && this.studentDob.length > 9) {

          console.log("In the validate student")

          this.validateStudent();

        } else {

          //this.invalidStudent = true;
          //this.validStudent = false;
        }
  },

  addStudent() {

    console.log(this.loginUuid);
    console.log(this.studentArray.studenT_ID);
    console.log(this.studentArray.companY_NAME);
    console.log(this.studentArray.firsT_NAME);

     var newDate = moment().tz("America/New_York").format("YYYY-MM-DD HH:mm:ss.SSS");

    this.postStudent(
      this.studentArray.studenT_ID,
      this.studentArray.companY_NAME,
      newDate,
      this.loginUuid,
      this.studentArray.firsT_NAME,
      this.studentArray.lasT_NAME,
      this.studentArray.householD_ID,
      this.studentArray.hangeR_ID,
      this.studentArray.grade,
      this.studentArray.homeroom,
      this.studentArray.birthday,
      newDate)

  },

  postStudent(studentId,companyName,dateAdded,logUuid,firstName,lastName,householdId,hangerId,grade,homeRoom,dob,removeDate) {

    const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
  };

  axios.post('https://api.conciergepadedu.com/api/Apps/StudentAdd',{ 
            STUDENT_ID: studentId,
            COMPANY_NAME: companyName,
            DATE_ADDED: dateAdded,
            LOGIN_UUID: logUuid,
            ACTIVE_FLAG: 'Y',
            FIRST_NAME: firstName,
            LAST_NAME: lastName,
            HOUSEHOLD_ID: householdId,
            HANGER_ID: hangerId,
            GRADE: grade,
            HOMEROOM: homeRoom,
            BIRTHDAY: dob,
            REMOVE_DATE: removeDate

      },auth).then(response => {


      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error);

          this.validStudent = false;
          this.invalidStudent = true;


      } else {

      console.log('success', response.data);
      this.validStudent = false;
      this.invalidStudent = false;

      this.addStudentArray = response.data;

      var hangerIdCheck = this.addStudentArray.householD_ID;

      this.getHangerId(this.studentId,hangerIdCheck,this.compName);


      if (hangerIdCheck !== '') {

        console.log("Student Added Successfully","Add","success");

      } else {

        console.log("No Household ID detected");

        //this.$alert("No Household ID detected","Add","error");
        
      }
   

   
      
      
      } 

  

        }).catch(error => {

            console.log(error.response);

              this.validStudent = false;
              this.invalidStudent = true;


        });

 

  },
 
  removeStudent(pId,studentId,firstName,lastName,dob,householdId,hangerId) {

    console.log(pId);

    var newDate = moment().tz("America/New_York").format("YYYY-MM-DD HH:mm:ss.SSS");

    console.log(newDate);

  this.$confirm("Are you sure?").then(() => {
  //do something...

 

  const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
  };

  axios.put('https://api.conciergepadedu.com/api/Apps/PutStudent/' + String(pId),{ 
         ID: pId,
         STUDENT_ID: studentId,
         FIRST_NAME: firstName,
         LAST_NAME: lastName,
         BIRTHDAY: dob,
         HOUSEHOLD_ID: householdId,
         HANGER_ID: hangerId,
         ACTIVE_FLAG: 'N',
         REMOVE_DATE: newDate,
         LOGIN_UUID: this.loginUuid,
         DATE_ADDED: newDate
      },auth).then(response => {


      if (response.data.error) {

          console.log("ERROR");
          console.log('error', response.data.error);



      } else {

      console.log('success', response.data);

      this.getStudents();

      this.$alert("Student Removed Successfully","Remove","success");

      } 

  

        }).catch(error => {

            console.log("CATCH");
            console.log(error.response);




        });

  });

  

   



    },

    updateUserButton(index) {

        console.log(this.items[index].firsT_NAME);
        console.log(this.items[index].lasT_NAME);

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };



  axios.put('https://api.conciergepadedu.com/api/Users/PutPush/' + String(this.items[index].id),{ 
         ID: this.items[index].id,
         USERNAME: this.items[index].username,
         PASSWORD:  this.items[index].password,
         COMPANY_NAME: this.items[index].companY_NAME,
         UUID: this.items[index].uuid,
         MOBILE_PHONE:  this.items[index].mobilE_PHONE,
         FIRST_NAME: this.items[index].firsT_NAME,
         LAST_NAME:this.items[index].lasT_NAME,
         EMAIL: this.items[index].username,
         DOB: this.items[index].dob,
         DATE_CREATED: this.items[index].datE_CREATED,
         HANGER_ID: this.items[index].hangeR_ID,
         PUSH_TOKEN: this.items[index].pusH_TOKEN
      },auth).then(response => {


      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error);

          this.validUpdate = false;
          this.invalidUpdate = true;

      } else {

      console.log('success', response.data);
      this.validUpdate = true;
      this.invalidUpdate = false;
      this.getAuthParents();
      this.sendEmail(this.items[index].username);
      
      } 

  

        }).catch(error => {

            console.log(error.response);

              this.validUpdate = false;
              this.invalidUpdate = true;




        });



    },

  uploadParentToApi(firstName,lastName,dob,companyName,studentId,studentRelation,hangerId, authEmail) {

  axios.post('https://api.conciergepadedu.com/api/Parents/PostParent',{ 
         FIRST_NAME: firstName,
         LAST_NAME: lastName,
         DOB: dob,
         COMPANY_NAME: companyName,
         AUTH_TYPE: 'Y',
         STUDENT_ID: studentId,
         DATE_ADDED: new Date(),
         STUDENT_RELATION: studentRelation,
         HANGER_ID: hangerId,
         AUTH_EMAIL: authEmail
      }).then(response => {


      if (response.data.error) {

        console.log('error', response.data.error)

      } else {

        console.log('success', response.data)
      }

     }).catch(error => {

        console.log(error.response)

      });

   
    },

    getAuthParents:function() {

    


      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      console.log("Bearer " + this.jwsToken)

      axios.get('https://api.conciergepadedu.com/api/Users/GetAuth/' +  this.hangerId + '/' + this.compName,auth).then(response => {


   

      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error)

 

      } else {

        console.log("**********************************")

        console.log(response.data);


        this.items = response.data;
        this.firstName = this.items.firsT_NAME;






        }



        }).catch(error => {

            console.log(error.response)




        });

    },
    sendEmail:function(email) {

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      console.log("Bearer " + this.jwsToken)

      axios.get('https://api.conciergepadedu.com/api/Users/SendEmail/' + email,auth).then(response => {


   

      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error)

 

      } else {

        console.log("**********************************")

        console.log(response.data);


        }



        }).catch(error => {

            console.log(error.response)




        });

    },
    getStudents:function() {

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      axios.get('https://api.conciergepadedu.com/api/Apps/GetLoginUUID/' +  this.loginUuid + '/' + this.compName,auth).then(response => {

      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error)

 

      } else {

        console.log("**********************************")

        console.log(response.data);


        this.students = response.data;

        }



        }).catch(error => {

            console.log(error.response)


        });

    },
    getHangerId:function(studentId, householdId, companyName) {
      this.hangerIdArray = [];
      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      axios.get('https://api.conciergepadedu.com/api/Hangers/' +  studentId + '/' + householdId + "/" + companyName,auth).then(response => {

      if (response.data.error) {

          console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
          console.log('error', response.data.error)

          this.studentId = '';
          this.studentDob = '';

          this.$alert("No Household ID Found, please contact school for more information. (error)","Add","error");

         

      } else {

        console.log(">>>>>>>SUCCESS>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");

        console.log(response.data);
        this.hangerIdArray = response.data;

     

        if (this.hangerIdArray) {

         this.getStudents();
         
         this.$alert("Student Added Successfully","Add","success");


         } else {

         this.$alert("No Household ID Found, please contact school for more information. (not found)","Add","error");

         }

        this.studentId = '';
        this.studentDob = '';
         

        }



        }).catch(error => {
          
            console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
            console.log(error.response)
            this.studentId = '';
            this.studentDob = '';
            this.$alert("No Household ID Found, please contact school for more information. (catch)","No Add","error")


        });

    },
    checkEmailGuardian() {

       if (this.guardianEmail == this.email) {

         this.validEmailGuardian = false;
         this.invalidEmailGuardian = true;
         this.alreadyRegistered = "Already registered as Guardian.  Don't have to input yourself."

       } else {

        this.validEmailGuardian = true;
        this.invalidEmailGuardian = false;
        this.alreadyRegistered = ""

        this.checkGuardian();

       }


    },
    checkGuardian:function() {

      axios.get('https://api.conciergepadedu.com/api/Users/CheckUser/' +  this.guardianEmail).then(response => {

      if (response.data.error) {

         console.log("ERROR");

        this.validEmailGuardian = true;
        this.invalidEmailGuardian = false;
        this.alreadyRegistered = "Email not registered"

      } else {

        console.log(response.data);

        //successful
        this.validEmailGuardian = false;
        this.invalidEmailGuardian = true;
        this.alreadyRegistered = "Email already registered"

        }

        }).catch(error => {

            console.log(error.response)

            this.validEmailGuardian = true;
            this.invalidEmailGuardian = false;
            this.alreadyRegistered = "Email not registered"

            if (this.guardianEmail.length == 0) {

            this.validEmailGuardian = false;
            this.invalidEmailGuardian = false;
            this.alreadyRegistered = "";

            }

        });

    },

      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>